import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      color: COLORS.neutral.mediumGray,
      fontWeight: theme.typography.fontWeightMedium,
    },
    tooltip: {},
    invalid: {
      color: theme.palette.error.main,
    },
  }),
  { name: 'TextAndWordCounter' }
);
